module.exports = __webpack_public_path__ + "static/media/wq_1.f91892ec.svg";